// extracted by mini-css-extract-plugin
export default {"banner":"banner___e6nZ4","icon":"icon___ioVfj","text":"text___f7mhf"};